<ion-app>
  <ion-router-outlet />
  <app-toast />
</ion-app>
